<template>
  <v-app>
    <Header></Header>
    <Sidebar v-if="$route.fullPath.includes('calculations')"></Sidebar>
    <v-main class="content mx-0 mx-md-2">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script type="text/javascript">
import Sidebar from "../../../../components/Sidebar/Sidebar.vue";
import Header from "../../../../components/Header/Header.vue";
export default {
  name: "CalculationsLayout",
  components: {Header, Sidebar},
}
</script>